import { Image as TiptapImage } from 'reactjs-tiptap-editor/extension-bundle';
import { fileService } from '../../../services/fileServices';
import { toast } from 'react-toastify';

const fileUploader = async files => {
  const { response, error } = await fileService.uploadFile(files);
  if (error) {
    return null;
  }

  const fileStreamUri = `${process.env.REACT_APP_API_URL}/files/stream/image/${response.filename}`;
  return fileStreamUri;
};

const uploadByUrl = async url => {
  try {
    // Upload the image from URL to our server
    const { response, error } = await fileService.uploadFileFromLink(url);

    if (error) {
      throw new Error('Error uploading image from URL:', error);
    }

    // Return our server's URL for the image
    const fileStreamUri = `${process.env.REACT_APP_API_URL}/files/stream/image/${response.fileName}`;
    return fileStreamUri;
  } catch (error) {
    throw error;
  }
};

// Extend the minified `Image` extension with additional functionality
export const ImageWithUpload = TiptapImage.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      upload: fileUploader
    };
  },

  addCommands() {
    const parentCommands = this.parent?.();

    return {
      ...parentCommands,
      setImageInline: options => ({ commands, editor }) => {
        const placeholderImage = `https://placehold.co/200x200?text=Loading...`;
        // If the source is a URL, use our uploadByUrl function
        if (!options?.src?.includes(process.env.REACT_APP_API_URL)) {
          // First insert the image with the original URL
          commands.insertContent({
            type: this.name,
            attrs: {
              ...options,
              src: placeholderImage
            }
          });

          // Then start the upload process
          uploadByUrl(options.src)
            .then(newUrl => {
              if (newUrl) {
                // Find the image node and update its src
                const { state } = editor;
                const { tr } = state;
                const imageNodes = [];

                // Find all image nodes in the document
                state.doc.descendants((node, pos) => {
                  if (node.type.name === this.name && node.attrs.src === placeholderImage) {
                    imageNodes.push({ node, pos });
                  }
                });

                // Update the most recently added image
                if (imageNodes.length > 0) {
                  const { pos } = imageNodes[imageNodes.length - 1];
                  tr.setNodeMarkup(pos, undefined, {
                    ...options,
                    src: newUrl
                  });
                  editor.view.dispatch(tr);
                }
              }
            })
            .catch(error => {
              toast.error('Error uploading image');
              // If the image is not uploaded, remove the image node
              const { state } = editor;
              const { tr } = state;
              const imageNodes = [];

              // Find all image nodes in the document
              state.doc.descendants((node, pos) => {
                if (node.type.name === this.name && node.attrs.src === placeholderImage) {
                  imageNodes.push({ node, pos });
                }
              });

              // Remove the image node
              if (imageNodes.length > 0) {
                const { pos } = imageNodes[imageNodes.length - 1];
                tr.delete(pos, pos + 1);
                editor.view.dispatch(tr);
              }
            });

          return true;
        }

        // Otherwise use the default image insertion
        return commands.insertContent({
          type: this.name,
          attrs: options
        });
      }
    };
  }
});

export default ImageWithUpload;
